// import React from "react";
// import { useTranslation } from "react-i18next";
// const ViewCatagory = ({ data }) => {
//   const { t } = useTranslation();

//   console.log("data ==>", data);
//   return (
//     <>
//       <div style={styles.container}>
//         {/* <h2 style={styles.title}>{data?.store_name}</h2> */}
//         <table style={styles.table}>
//           <tbody>
//             <tr style={{ borderBottom: "1px dotted black" }}>
//               <td>{t("Title")}</td>
//               <td>{t("Details")}</td>
//             </tr>
//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}> {t("Name")}:</td>
//               <td>{data?.name}</td>
//             </tr>
//             <tr>
//               <td style={styles.label}> {t("Description")}:</td>
//               <td>
//                 <td>{data?.description}</td>
//               </td>
//             </tr>

//           </tbody>
//         </table>
//       </div>
//     </>
//   );
// };
// const styles = {
//   container: {
//     maxWidth: "50rem",
//     minWidth: "50rem",
//     margin: "auto",
//     padding: "20px",
//     // backgroundColor: "#f0f0f0",
//     borderRadius: "8px",
//     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//   },
//   title: {
//     textAlign: "center",
//     color: "#333",
//     marginBottom: "20px",
//   },
//   table: {
//     width: "100%",
//   },
//   label: {
//     fontWeight: "600",
//     paddingRight: "10px",
//     verticalAlign: "top",
//     padding: "1rem",
//   },
//   select: {
//     width: "100%",
//     padding: "8px",
//     borderRadius: "4px",
//     border: "1px solid #ccc",
//     fontSize: "14px",
//     marginTop: "5px",
//   },
// };

// export default ViewCatagory;

import { background, color } from "@chakra-ui/system";
import { CONSTANTS } from "config/constant";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { API_GET_CATAGORY } from "api/catagory-managemnt";
import { useParams } from "react-router-dom";

const ViewCatagory = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const navigate = useNavigate();
  const [data, setData] = useState();
  const [loading, setLoading] = useState();
  let { id } = useParams();

  const fetchData = async () => {
    setLoading(true);
    try {
      const newData = await API_GET_CATAGORY(id);
      console.log("provider", newData);
      setData(newData?.category);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  // const data = location.state && location.state.data;
  return (
    <div className="flex gap-8">
      <div style={styles.container} className="min-h-[37rem]">
        <table style={styles.table}>
          <tbody>
            <div
              className="flex cursor-pointer items-center gap-2"
              onClick={() => {
                navigate(-1);
              }}
            >
              <MdOutlineArrowBack
                className="cursor-pointer"
                style={{ fontSize: "17px" }}
              />
              <p>Back</p>
            </div>
            <p className="mb-4 text-center text-[20px] font-semibold">
              View Catagory
            </p>
            <hr className="mb-4" />
            <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Name")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {/* {data?.name} */}
                  {data?.title}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Description")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.description}
                </td>
              </tr>
              {/* <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px]"
                  style={styles.label}
                >
                  {t("Role Status")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] font-semibold">
                  {data?.role_status === true ? "Active" : "Non-Active"}
                </td>
              </tr> */}
            </div>
          </tbody>
        </table>
      </div>
    </div>
  );
};
const styles = {
  container: {
    margin: "auto",
    width: "80%",
    padding: "20px",
    background: "white",
    borderRadius: "8px",
    boxShadow: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
  },
  table: {
    width: "100%",
  },
  label: {
    paddingRight: "10px",
    verticalAlign: "top",
    padding: "1rem",
  },
};

export default ViewCatagory;
